import { MoneyMessage } from '../../../../types/MoneyMessage';
import { authorizedAxiosInstance } from '../instances/AuthorizedAxiosInstance';

export interface ContractPackagePriceRequestMessage {
    portId: string;
    customerId: string;
    vesselId?: string;
    contractId: string;
    packType: string;
    productId: string;
}

export interface ContractPackagePriceResponseMessage {
    contractId: string | null;
    priceListId: string | null;
    customerId: string;
    supplierId: string | null;
    portId: string;
    price: MoneyMessage | null;
    productId: string;
    packType: string;
    isOutdated: boolean;
    validUntil: string | null;
}

export const calculateContractPackagePrices = async (
    contractPackagePricesRequest: ContractPackagePriceRequestMessage[],
    deliveryDate?: string
): Promise<ContractPackagePriceResponseMessage[]> => {
    const response = await authorizedAxiosInstance.post('/v2/prices', {
        priceRequests: contractPackagePricesRequest,
        deliveryDate,
    });

    return response.data.prices;
};
